<template>
    <div class="header-action">
        <a
            class="header-action__link"
            :class="{
                'header-action__link--active': active
            }"
            @click="$emit('click')"
        >
            <slot></slot>
        </a>
        <slot name="append"></slot>
    </div>
</template>

<script>
export default {
    name: 'HeaderAction',

    props: {
        active: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.header-action {
    line-height: 1;
    flex-shrink: 0;

    &__link {
        display: inline-flex;
        color: #fff;
        font-size: 14px;
        letter-spacing: 2px;
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 4px;
        align-items: center;
        white-space: nowrap;

        &--active,
        &:hover {
            background: #24252c;
        }
    }
}
</style>
